import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { r as o } from "../internals/require-object-coercible.js";
import { t as i } from "../internals/to-string.js";
var n = t("".charCodeAt);
r({
  target: "String",
  proto: !0
}, {
  isWellFormed: function isWellFormed() {
    for (var r = i(o(this)), t = r.length, e = 0; e < t; e++) {
      var s = n(r, e);
      if ((63488 & s) == 55296 && (s >= 56320 || ++e >= t || (64512 & n(r, e)) != 56320)) return !1;
    }
    return !0;
  }
});